/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Issue_Cost_LockedInputs */

const en_po_issue_cost_locked = /** @type {(inputs: Po_Issue_Cost_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no longer changes after a receipt or an invoice`)
};

/**
* | output |
* | --- |
* | "no longer changes after a receipt or an invoice" |
*
* @param {Po_Issue_Cost_LockedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_issue_cost_locked = /** @type {((inputs?: Po_Issue_Cost_LockedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Issue_Cost_LockedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_issue_cost_locked(inputs)
});